import { OrgLevelTypeEnum } from "../enums/orgLevelType.enum";

export class SegOrgLevel {
    id?: string;
    segId: string;
    organizationLevelId: string;
    shiftId?: string | null;
    shiftName?: string;
    numberOfWorkers?: number | null;
    numberOfContractors?: number | null;
    shiftLengthHours?: number | null;
    shiftType?: number | null;
    avgWeeklyHours?: number | null;
    SegName?: string;
    OrgLevelName?: string;
    OrgLevelType?: OrgLevelTypeEnum;
    organizationLevelName?: string;
}

export interface SegOrgLevelRow extends SegOrgLevel {
    isNew?: boolean;
    isRemoved?: boolean;
    shiftTypeLabel?: string;
}

export interface SegOrgLevelRecordHistory {
    id: string;
    entityId: string;
    segId: string;
    organizationLevelId: string;
    organizationLevelName?: string | null;
    shiftId?: string | null;
    shiftLengthHours?: number | null;
    avgWeeklyHours?: number | null;
    shiftType?: number | null;
    numberOfWorkers?: number | null;
    numberOfContractors?: number | null;
    dateUpdated: string;
    updatedByUserId?: string | null;
    updatedByUserName?: string | null;
    changedFields?: string;
}

export type SegOrgLevelHistoryField = keyof Pick<SegOrgLevelRecordHistory,
    'shiftId' | 'shiftLengthHours' | 'avgWeeklyHours' | 'shiftType' | 'numberOfWorkers' | 'numberOfContractors'>;

export interface SegOrgLevelHistoryRow extends SegOrgLevelRecordHistory {
    changed: Partial<Record<SegOrgLevelHistoryField, boolean>>;
    isInitial: boolean;
    isRemoved: boolean;
    shiftName?: string;
    shiftTypeLabel?: string;
    dateUpdatedDisplay: string;
}

export interface SegOrgLevelHistoryScopeOption {
    id: string;
    name: string;
    isRemoved: boolean;
}
